import React, {useState, useEffect, useRef } from 'react';
import { useParams, Redirect } from "react-router-dom";

import "../Pagina.css";
import "../content-styles.css"
import "./Assistance.css"

import Swal from 'sweetalert2'

import * as Hosts from '../../../Hosts';
import {
	reqGET,
	reqPUT,
	reqPOST,
    profile_access,
    functionSendMail
} from '../../../Utils';

import { usarToken } from "../../../UseToken";

import Loader from '../../../loader'

import Navbar from "../Navbar/Navbar_00";
import Breadcrumb from "../Breadcrumb/Breadcrumb";
import Footer from "../Footer/Footer_00";

import { language } from './Language';

export default function Assistance(props) {

    const [, set_dados] = useState(null);
    const is_logged_in = useRef(null);
    const assistance_list = useRef(null);
    const assistance_selected_list = useRef(null);
    const assistance_archive_list = useRef(null);
    const assistance_archive_selected_list = useRef(null);
    const assistance_new = useRef(null);
    const assistance_info = useRef(null);

    const assistance_user_names = useRef(null);
    const colaboradores_list = useRef(null);
      
    const [dados_config, set_dados_config] = useState({});
    const [dados_navbar, set_dados_navbar] = useState({});

    const [type, ] = useState('assistance')

    const [user_info, set_user_info] = useState({})
    const [services, set_services] = useState([])

    const [user_name_by_id, set_user_name_by_id] = useState([])
    const [user_access_level, set_user_access_level] = useState(0)
    const [interaction, set_interaction] = useState('')
    const [response, set_response] = useState('')

    const [selected_user_id, set_selected_user_id] = useState('')

    const [isloading, setLoading] = useState(true)
    const [isRedirect, setRedirect] = useState(false)
    const [, setRefresh] = useState(0)

    const [is_edit, set_is_edit] = useState(false)

    const [show_archive, set_show_archive] = useState(false)

    const [lang, set_lang] = useState('pt')

    const [close, set_close] = useState(false)

    useEffect(() => {

        (async () => {

            set_dados(assistance_user_names.current = [])
            set_dados(colaboradores_list.current = [])
            set_dados(assistance_selected_list.current = [])
            set_dados(assistance_archive_selected_list.current = [])

            let aux_assistance = {
                id: '',
                info: {
                    id_user: '',
                    type: type,
                    companycode: Hosts.companycode,
                    date: '',
                    name: '',
                    message: '',
                    service: {
                        id: '', 
                        name: ''
                    },
                    state: '0',         // 0 - iniciada | 1 - em curso | 2 - resolvida
                    interaction: []
                }
            }
            let aux_interaction = {
                id_user: '',
                date: '',
                message: '',
                state: '0',             // 0 - não lida | 1 lida
            }
            set_dados(assistance_new.current = aux_assistance)
            set_interaction(aux_interaction)

            let temp_token_info = await usarToken().getToken()
            let token_info = JSON.parse(temp_token_info)
            
            if(token_info !== undefined && token_info !== null && token_info.user_info !== undefined) {
                set_dados(is_logged_in.current = true)
            }
            else {
                set_dados(is_logged_in.current = false)
            }

            if(is_logged_in.current) {
                if(props.dados_navbar !== undefined && props.dados_navbar !== null && props.dados_navbar !== '') {
                    set_dados_navbar(props.dados_navbar)
                }
            }

            if(props.dados_config !== undefined && props.dados_config !== null && props.dados_config !== '') {
                set_dados_config(props.dados_config)
            }

            let res_c = await reqGET(`${Hosts.SIMCore_API}/entities/special/${Hosts.companycode}/Colaborador`)
            if(res_c.data.length > 0) {
                set_dados(colaboradores_list.current = res_c.data)
            }

            let getClientAssistances = async (id_user) => {

                let aux_names = []
                let name_aux = await get_user_name(id_user)
                if(name_aux !== undefined && name_aux !== null && name_aux !== '') {
                    aux_names.push({
                        id: id_user,
                        info: {
                            name: name_aux.name,
                            email: name_aux.email
                        }

                    })
                }
                set_dados(assistance_user_names.current = aux_names)

                let res_s = await reqGET(`${Hosts.SIMCore_API}/web/support/attributes/type/${Hosts.companycode}/service`)
                if(res_s.data.length > 0) {
                    set_services(res_s.data)
                }

                let res = await reqGET(`${Hosts.SIMCore_API}/web/support/type/user/${Hosts.companycode}/${type}/${id_user}`)
                if(res.data.length > 0) {
                    set_dados(assistance_list.current = res.data)
                }
                else {
                    set_dados(assistance_list.current = [])
                }
                setLoading(false)

            }
            let getCollaboratorAssistances = async () => {

                let res_s = await reqGET(`${Hosts.SIMCore_API}/web/support/attributes/type/${Hosts.companycode}/service`)
                if(res_s.data.length > 0) {
                    set_services(res_s.data)
                }

                let res = await reqGET(`${Hosts.SIMCore_API}/web/support/type/open/${Hosts.companycode}/${type}`)
                // let res = await reqGET(`${Hosts.SIMCore_API}/web/support/type/${Hosts.companycode}/${type}/order`)
                if(res.data.length > 0) {

                    let al_aux = []
                    if(res.data !== undefined && res.data !== null) {
                        let aux_names = []
                        // res.data.forEach(async el => {
                        for await (let el of res.data) {
                            let aux = aux_names.filter(e => parseInt(e.id) === parseInt(el.info.id_user))
                            if(aux.length === 0) {
                                let name_aux = await get_user_name(el.info.id_user)
                                if(name_aux !== undefined && name_aux !== null && name_aux !== '') {
                                    aux_names.push({
                                        id: el.info.id_user,
                                        info: {
                                            name: name_aux.name,
                                            email: name_aux.email
                                        }

                                    })
                                }
                            }

                            al_aux.push(el)
                        }
                        //})
                        set_dados(assistance_user_names.current = aux_names)
                    }

                    // set_dados(assistance_list.current = res.data)
                    set_dados(assistance_list.current = al_aux)
                }
                else {
                    set_dados(assistance_list.current = [])
                }

                let res_c = await reqGET(`${Hosts.SIMCore_API}/web/support/type/${Hosts.companycode}/${type}/order`)
                if(res_c.data.length > 0) {

                    let ala_aux = []
                    if(res_c.data !== undefined && res_c.data !== null) {
                        let aux_names = []
                        // res_c.data.forEach(async el => {
                        for await (let el of res_c.data) {
                            let aux = aux_names.filter(e => parseInt(e.id) === parseInt(el.info.id_user))
                            if(aux.length === 0) {
                                let name_aux = await get_user_name(el.info.id_user)
                                if(name_aux !== undefined && name_aux !== null && name_aux !== '') {
                                    aux_names.push({
                                        id: el.info.id_user,
                                        info: {
                                            name: name_aux.name,
                                            email: name_aux.email
                                        }

                                    })
                                }
                            }

                            if(parseInt(el.info.state) === 2) {
                                ala_aux.push(el)
                            }
                        }
                        //})
                        set_dados(assistance_user_names.current = aux_names)
                    }

                    // set_dados(assistance_list.current = res_c.data)
                    set_dados(assistance_archive_list.current = ala_aux)

                    setLoading(false)
                }
                else {
                    set_dados(assistance_archive_list.current = [])

                    setLoading(false)
                }
            }

            if (token_info !== undefined && token_info !== null && token_info.user_info !== undefined && token_info.user_info !== null && token_info.user_info.id !== '') {

                let profile_access_aux = profile_access.find(el => el.name.toLowerCase() === token_info.user_info.profile.toLowerCase())
                if(profile_access_aux !== undefined && profile_access_aux !== null) {
                    set_user_access_level(profile_access_aux.level)
                }

                set_user_info(token_info.user_info)

                if(parseInt(profile_access_aux.level) >= 5) {
                    await getCollaboratorAssistances(token_info.user_info.id)
                }
                else {
                    await getClientAssistances(token_info.user_info.id)
                }

            }
            else {
                setRedirect(true)
            }

        })()

        if(localStorage.getItem('lang') !== undefined  || localStorage.getItem('lang') !== null) {
            set_lang(localStorage.getItem('lang'))
        }

    }, [props, type]);

    const handleSubmit = async (e) => {
		e.preventDefault();

        assistance_new.current.info.id_user = user_info.id
        assistance_new.current.info.date = new Date()

        if(is_edit) {

            console.log('edit')

        }
        else {
            await reqPOST(`${Hosts.SIMCore_API}/web/support`, assistance_new.current)
                .then(async () => {

                    let today = new Date();
                    let today_aux = String(today.getDate()).padStart(2, '0') + '-' + String(today.getMonth() + 1).padStart(2, '0') + '-' + today.getFullYear();

                    let mail_content =  '<table width="600" cellpadding="0" cellspacing="0" border="0" align="0" class="0" style="width: 600px; height: 90px; padding: 15px 30px; background-color:' + Hosts.EMAIL_BACKGROUND_COLOR +'; border:1px solid transparent; border-collapse:collapse;">' +
                        '<tr style="border-collapse: collapse;">' +
                            '<td align="left" style="padding: 30px 40px 0px; font-family:poppins, helvetica, arial, sans-serif; font-size:' + Hosts.EMAIL_TEXT_SIZE +'; line-height:' + Hosts.EMAIL_TEXT_LINE_HEIGHT  +'; color:' + Hosts.EMAIL_TEXT_COLOR +'">' +
                                '<div>' +
                                    '<span><b>' + language[lang].assistance + '</b></span>' +
                                '</div>' +
                            '</td>' + 
                            '<td align="right" style="padding: 30px 40px 0px; font-family:poppins, helvetica, arial, sans-serif; font-size:' + Hosts.EMAIL_TEXT_SIZE +'; line-height:' + Hosts.EMAIL_TEXT_LINE_HEIGHT  +'; color:' + Hosts.EMAIL_TEXT_COLOR +'">' +
                                '<div>'+
                                    '<span>'+ today_aux + '</span>'+
                                '</div>'+
                            '</td>' +
                        '</tr>' +

                        '<tr>' +
                            '<td colspan="2" align="right" style="padding: 0px 40px; height: 15px;"></td>' +
                        '</tr>' +

                        '<tr style="border-collapse: collapse;">' +
                            '<td colspan="2" align="left" style="padding:40px; border-collapse:collapse; font-family:poppins, helvetica, arial, sans-serif; font-size:' + Hosts.EMAIL_TEXT_SIZE +'; line-height:' + Hosts.EMAIL_TEXT_LINE_HEIGHT  +'; color:' + Hosts.EMAIL_TEXT_COLOR +'">' +
                                '<div>'+
                                    '<span><b>'+ language[lang].service +': </b><label>' + assistance_new.current.info.service.name + '</label></span>' +
                                    '<br/>'+
                                    '<span><b>'+ language[lang].assistance +': </b><label>' + assistance_new.current.info.name + '</label></span>' +
                                    '<br/>'+
                                    '<span><b>'+ language[lang].message +': </b><label>' + assistance_new.current.info.message + '</label></span>' +
                                    '<br/>'+
                                '</div>'+
                            '</td>' +
                        '</tr>' +
                    '</table>'

                    let sendFrom = Hosts.contactFrom
                    let sendTo = [user_info.username]
                    let sendToCC = ['web.dev@assec.pt']
                    let subject = language[lang].subject_assistance_email
                    let content = mail_content
                    let attachment = []
                    
                    sendToCC.push(Hosts.contactFrom4)

                    colaboradores_list.current.forEach(el_cl => {
                        if(el_cl.contacts[0].email !== '') {
                            sendToCC.push(el_cl.contacts[0].email)
                        }
                    })

                    await functionSendMail(sendFrom, sendTo, sendToCC, subject, content, attachment, dados_config)

                    Swal.fire('', language[lang].assistance_success, 'info')

                    setTimeout(() => {
                        window.location.reload()
                    }, 3000);

                })
                .catch(() => {
                    Swal.fire(language[lang].assistance_error, '', 'info')
                })
        }

	}

    const handle_change_info = (e) => {
        const { name, value } = e.target;

        set_dados(assistance_new.current.info[name] = value)

        setRefresh(r => r + 1)

    }

    const handle_change_info_service = (e) => {
        const { name, value } = e.target;

        console.log('name', name)
        console.log('value', value)

        let service_selected = services.filter(el => parseInt(el.id) === parseInt(value))

        if(service_selected.length > 0) {
            let s_aux = {
                id: value,
                name: service_selected[0].info.name
            }

            set_dados(assistance_new.current.info['service'] = s_aux)
        }
        setRefresh(r => r + 1)

    }

    const dateDifferenceInHours = (dateInitial, dateFinal) => {

        let formattedDateInitial = dateInitial
        let formattedDateFinal = dateFinal

        let result = 0
        let text = language[lang].time_seconds
        result = Math.floor((formattedDateFinal - formattedDateInitial) / 1_000);
        if(result > 60) {
            result =  Math.floor((formattedDateFinal - formattedDateInitial) / 60_000);
            text = result === 1 ? language[lang].time_minute : language[lang].time_minutes

            if(result > 60) {            
                result =  Math.floor((formattedDateFinal - formattedDateInitial) / 3_600_000);
                text = result === 1 ? language[lang].time_hour : language[lang].time_hours

                if(result > 24) {
                    result =  Math.floor((formattedDateFinal - formattedDateInitial) / 86_400_000);
                    text = result === 1 ? language[lang].time_day : language[lang].time_days

                    if(result > 15) {
                        result =  Math.floor((formattedDateFinal - formattedDateInitial) / 604_800_000);
                        text = result === 1 ? language[lang].time_week : language[lang].time_weeks

                        if(result > 60) {
                            result =  Math.floor(Math.max(
                                (dateFinal.getFullYear() - dateInitial.getFullYear()) * 12 +
                                  dateFinal.getMonth() -
                                  dateInitial.getMonth(),
                                0
                            ));
                            text = result === 1 ? language[lang].time_month : language[lang].time_months
                            
                            if(result > 60) {
                                result =  Math.floor((formattedDateFinal - formattedDateInitial) / 12);
                                text = result === 1 ? language[lang].time_year : language[lang].time_years
                            }
                        }
                    }
                }
            }
        }

        return result + ' ' + text

    }

    const dateString = (dateInitial) => {

        console.log('dateInitial', dateInitial)
        let data = dateInitial.split('T')[0]
        let hora = dateInitial.split('T')[1]
        
        let ano = data.split('-')[0]
        let mes = data.split('-')[1]
        let dia = data.split('-')[2]

        let horas = hora.split(':')[0]
        let minutos = hora.split(':')[1]

        return dia + '-' + mes + '-' + ano + ' ' + language[lang].at + ' ' + horas + ':' + minutos

    }

    const get_user_name = async (id) => {

        let result = ''
        let aux_user = await reqGET(`${Hosts.SIMCore_API}/entities/${Hosts.companycode}/${id}`)
        if(aux_user.data !== undefined && aux_user.data.length > 0) {
            result = { 
                name: aux_user.data[0].info.name,
                email: aux_user.data[0].contacts[0].email
            }
        }
        return result
    }

    const show_ticket = async (id) => {

        let users_name_aux = []

        let s_aux = assistance_list.current.filter(el => el.id === id)
        if(s_aux !== undefined && s_aux !== null && s_aux.length === 0) {
            s_aux = assistance_archive_list.current.filter(el => el.id === id)
        }
        if(s_aux !== undefined && s_aux.length > 0) {

            if(parseInt(s_aux[0].info.id_user) !== parseInt(user_info.id)) {
                if(parseInt(s_aux[0].info.state) === 0) {
                    s_aux[0].info.state = 1
        
                    await reqPUT(`${Hosts.SIMCore_API}/web/support`, s_aux[0])
                }
        
                s_aux[0].info.interaction.forEach(async (el) => {
                    if((parseInt(el.id_user) !== parseInt(user_info.id)) && parseInt(el.state) === 0) {
                        el.state = 1
        
                        await reqPUT(`${Hosts.SIMCore_API}/web/support`, s_aux[0])
                    }
                })
            }
            else {
        
                s_aux[0].info.interaction.forEach(async (el) => {
                    if((parseInt(el.id_user) !== parseInt(user_info.id)) && parseInt(el.state) === 0) {
                        el.state = 1
        
                        await reqPUT(`${Hosts.SIMCore_API}/web/support`, s_aux[0])
                    }
                })

            }

            let name_aux = await get_user_name(s_aux[0].info.id_user)
            users_name_aux.push({
                id: s_aux[0].info.id_user,
                name: name_aux.name,
                email: name_aux.email
            })

            for await(let el of s_aux[0].info.interaction) {
                
                let f_aux = users_name_aux.filter(el_f => el_f.id === el.id_user)
                if(f_aux !== undefined && f_aux.length === 0) {
                    let user_name_interaction_aux = await get_user_name(el.id_user)
                    users_name_aux.push({
                        id: el.id_user,
                        name: user_name_interaction_aux.name,
                        email: user_name_interaction_aux.email
                    })
                }
            }
            
            // console.log('users_name_aux', users_name_aux)
            set_user_name_by_id(users_name_aux)
            set_dados(assistance_info.current = s_aux[0])
            // console.log('s_aux[0]', s_aux[0])
        }

    }

    const show_archived_ticket = async (id) => {

        let users_name_aux = []

        let s_aux = assistance_archive_list.current.filter(el => el.id === id)
        if(s_aux !== undefined && s_aux !== null && s_aux.length === 0) {
            s_aux = assistance_list.current.filter(el => el.id === id)
        }
        if(s_aux !== undefined && s_aux.length > 0) {

            if(parseInt(s_aux[0].info.id_user) !== parseInt(user_info.id)) {
                if(parseInt(s_aux[0].info.state) === 0) {
                    s_aux[0].info.state = 1
        
                    await reqPUT(`${Hosts.SIMCore_API}/web/support`, s_aux[0])
                }
        
                s_aux[0].info.interaction.forEach(async (el) => {
                    if((parseInt(el.id_user) !== parseInt(user_info.id)) && parseInt(el.state) === 0) {
                        el.state = 1
        
                        await reqPUT(`${Hosts.SIMCore_API}/web/support`, s_aux[0])
                    }
                })
            }
            else {
        
                s_aux[0].info.interaction.forEach(async (el) => {
                    if((parseInt(el.id_user) !== parseInt(user_info.id)) && parseInt(el.state) === 0) {
                        el.state = 1
        
                        await reqPUT(`${Hosts.SIMCore_API}/web/support`, s_aux[0])
                    }
                })

            }

            let name_aux = await get_user_name(s_aux[0].info.id_user)
            users_name_aux.push({
                id: s_aux[0].info.id_user,
                name: name_aux.name,
                email: name_aux.email
            })

            for await(let el of s_aux[0].info.interaction) {
                
                let f_aux = users_name_aux.filter(el_f => el_f.id === el.id_user)
                if(f_aux !== undefined && f_aux.length === 0) {
                    let user_name_interaction_aux = await get_user_name(el.id_user)
                    users_name_aux.push({
                        id: el.id_user,
                        name: user_name_interaction_aux.name,
                        email: user_name_interaction_aux.email
                    })
                }
            }
            
            // console.log('users_name_aux', users_name_aux)
            set_user_name_by_id(users_name_aux)
            set_dados(assistance_info.current = s_aux[0])
            // console.log('s_aux[0]', s_aux[0])
        }

    }

    const edit_response = (e) => {
        const { value } = e.target;

        set_response(value)

    } 

    const send_response = async () => {
        
        if(response !== '') {
            interaction.id_user = user_info.id
            interaction.date = new Date()
            interaction.message = response

            // console.log('interaction', interaction)

            if(close) {
                assistance_info.current.info.state = 2
                assistance_info.current.info['close_date'] = new Date()
            }

            assistance_info.current.info.interaction.push(JSON.parse(JSON.stringify(interaction)))

            await reqPUT(`${Hosts.SIMCore_API}/web/support`, assistance_info.current)

            if(parseInt(user_info.id) !== parseInt(assistance_info.current.info.id_user)) {
                let user_email_aux = user_name_by_id.filter(e => e.id === assistance_info.current.info.id_user).pop()

                let today = new Date();
                let today_aux = String(today.getDate()).padStart(2, '0') + '-' + String(today.getMonth() + 1).padStart(2, '0') + '-' + today.getFullYear();

                let mail_content =  '<table width="600" cellpadding="0" cellspacing="0" border="0" align="0" class="0" style="width: 600px; height: 90px; padding: 15px 30px; background-color:' + Hosts.EMAIL_BACKGROUND_COLOR +'; border:1px solid transparent; border-collapse:collapse;">' +
                    '<tr style="border-collapse: collapse;">' +
                        '<td align="left" style="padding: 30px 40px 0px; font-family:poppins, helvetica, arial, sans-serif; font-size:' + Hosts.EMAIL_TEXT_SIZE +'; line-height:' + Hosts.EMAIL_TEXT_LINE_HEIGHT  +'; color:' + Hosts.EMAIL_TEXT_COLOR +'">' +
                            '<div>' +
                                '<span><b>' + language[lang].assistance + '</b></span>' +
                            '</div>' +
                        '</td>' + 
                        '<td align="right" style="padding: 30px 40px 0px; font-family:poppins, helvetica, arial, sans-serif; font-size:' + Hosts.EMAIL_TEXT_SIZE +'; line-height:' + Hosts.EMAIL_TEXT_LINE_HEIGHT  +'; color:' + Hosts.EMAIL_TEXT_COLOR +'">' +
                            '<div>'+
                                '<span>'+ today_aux + '</span>'+
                            '</div>'+
                        '</td>' +
                    '</tr>' +

                    '<tr>' +
                        '<td colspan="2" align="right" style="padding: 0px 40px; height: 15px;"></td>' +
                    '</tr>' +

                    '<tr style="border-collapse: collapse;">' +
                        '<td colspan="2" align="left" style="padding:40px; border-collapse:collapse; font-family:poppins, helvetica, arial, sans-serif; font-size:' + Hosts.EMAIL_TEXT_SIZE +'; line-height:' + Hosts.EMAIL_TEXT_LINE_HEIGHT  +'; color:' + Hosts.EMAIL_TEXT_COLOR +'">' +
                            '<div>'+
                                '<span>' + (close ? language[lang].assistance_closed_email_sent : language[lang].assistance_response_email_sent) + '</span>'+
                            '</div>'+
                        '</td>' +
                    '</tr>' +

                    '<tr style="border-collapse: collapse;">' +
                        '<td colspan="2" align="left" style="padding:0px 40px;border-collapse:collapse; font-family:poppins, helvetica, arial, sans-serif; font-size:' + Hosts.EMAIL_TEXT_SIZE +'; line-height:' + Hosts.EMAIL_TEXT_LINE_HEIGHT  +'; color:' + Hosts.EMAIL_TEXT_COLOR +'">' +
                            '<div>'+
                                language[lang].access_app_txt +  ' <a alt="' + Hosts.webSiteTitle + '" title="' + Hosts.webSiteTitle + '" href="' + Hosts.EMAIL_WEB_SITE_URL + '" target="_blank">'+ language[lang].access_app_link +'</a>'+
                            '</div>'+
                        '</td>' +
                    '</tr>' +
                
                    '<tr>' +
                        '<td colspan="2" align="right" style="height: 15px;"></td>' +
                    '</tr>' +
                '</table>'

                let sendFrom = Hosts.contactFrom
                let sendTo = [user_email_aux.email]
                let sendToCC = ['web.dev@assec.pt']
                let subject = language[lang].subject_assistance_email
                let content = mail_content
                let attachment = []

                await functionSendMail(sendFrom, sendTo, sendToCC, subject, content, attachment, dados_config)
            }
            else {
                let today = new Date();
                let today_aux = String(today.getDate()).padStart(2, '0') + '-' + String(today.getMonth() + 1).padStart(2, '0') + '-' + today.getFullYear();

                let mail_content =  '<table width="600" cellpadding="0" cellspacing="0" border="0" align="0" class="0" style="width: 600px; height: 90px; padding: 15px 30px; background-color:' + Hosts.EMAIL_BACKGROUND_COLOR +'; border:1px solid transparent; border-collapse:collapse;">' +
                    '<tr style="border-collapse: collapse;">' +
                        '<td align="left" style="padding: 30px 40px 0px; font-family:poppins, helvetica, arial, sans-serif; font-size:' + Hosts.EMAIL_TEXT_SIZE +'; line-height:' + Hosts.EMAIL_TEXT_LINE_HEIGHT  +'; color:' + Hosts.EMAIL_TEXT_COLOR +'">' +
                            '<div>' +
                                '<span><b>' + language[lang].assistance + '</b></span>' +
                            '</div>' +
                        '</td>' + 
                        '<td align="right" style="padding: 30px 40px 0px; font-family:poppins, helvetica, arial, sans-serif; font-size:' + Hosts.EMAIL_TEXT_SIZE +'; line-height:' + Hosts.EMAIL_TEXT_LINE_HEIGHT  +'; color:' + Hosts.EMAIL_TEXT_COLOR +'">' +
                            '<div>'+
                                '<span>'+ today_aux + '</span>'+
                            '</div>'+
                        '</td>' +
                    '</tr>' +

                    '<tr>' +
                        '<td colspan="2" align="right" style="padding: 0px 40px; height: 15px;"></td>' +
                    '</tr>' +

                    '<tr style="border-collapse: collapse;">' +
                        '<td colspan="2" align="left" style="padding:40px; border-collapse:collapse; font-family:poppins, helvetica, arial, sans-serif; font-size:' + Hosts.EMAIL_TEXT_SIZE +'; line-height:' + Hosts.EMAIL_TEXT_LINE_HEIGHT  +'; color:' + Hosts.EMAIL_TEXT_COLOR +'">' +
                            '<div>'+
                                '<span>' + (close ? language[lang].assistance_closed_email_sent : language[lang].assistance_response_email_sent) + '</span>'+
                            '</div>'+
                        '</td>' +
                    '</tr>' +

                    '<tr style="border-collapse: collapse;">' +
                        '<td colspan="2" align="left" style="padding:0px 40px;border-collapse:collapse; font-family:poppins, helvetica, arial, sans-serif; font-size:' + Hosts.EMAIL_TEXT_SIZE +'; line-height:' + Hosts.EMAIL_TEXT_LINE_HEIGHT  +'; color:' + Hosts.EMAIL_TEXT_COLOR +'">' +
                            '<div>'+
                                language[lang].access_app_txt +  ' <a alt="' + Hosts.webSiteTitle + '" title="' + Hosts.webSiteTitle + '" href="' + Hosts.EMAIL_WEB_SITE_URL + '" target="_blank">'+ language[lang].access_app_link +'</a>'+
                            '</div>'+
                        '</td>' +
                    '</tr>' +
                
                    '<tr>' +
                        '<td colspan="2" align="right" style="height: 15px;"></td>' +
                    '</tr>' +
                '</table>'

                let sendFrom = Hosts.contactFrom
                let sendTo = [Hosts.contactFrom]
                let sendToCC = ['web.dev@assec.pt']
                let subject = language[lang].subject_assistance_email
                let content = mail_content
                let attachment = []
                
                sendToCC.push(Hosts.contactFrom4)

                colaboradores_list.current.forEach(el_cl => {
                    if(el_cl.contacts[0].email !== '') {
                        sendToCC.push(el_cl.contacts[0].email)
                    }
                })

                await functionSendMail(sendFrom, sendTo, sendToCC, subject, content, attachment, dados_config)
            }

            interaction.id_user = user_info.id
            interaction.date = ''
            interaction.message = ''
            set_response('')

            // console.log('assistance_info.current.info.interaction', assistance_info.current.info.interaction)

            setRefresh(r => r + 1)
        }

    }

    const close_ticket = async () => {

        await Swal.fire({
			title: language[lang].assistance_close,
			text: language[lang].assistance_close_confirm,
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#0095e8',
			cancelButtonColor: '#d9214e',
			confirmButtonText: language[lang].confirm,
			cancelButtonText: language[lang].cancel
		})
		.then(async (result) => {
			if (result.isConfirmed) {
                assistance_info.current.info.state = 2
                assistance_info.current.info['close_date'] = new Date()

                await reqPUT(`${Hosts.SIMCore_API}/web/support`, assistance_info.current)

                if(parseInt(user_info.id) !== parseInt(assistance_info.current.info.id_user)) {
                    let user_email_aux = user_name_by_id.filter(e => e.id === assistance_info.current.info.id_user).pop()

                    let today = new Date();
                    let today_aux = String(today.getDate()).padStart(2, '0') + '-' + String(today.getMonth() + 1).padStart(2, '0') + '-' + today.getFullYear();

                    let mail_content =  '<table width="600" cellpadding="0" cellspacing="0" border="0" align="0" class="0" style="width: 600px; height: 90px; padding: 15px 30px; background-color:' + Hosts.EMAIL_BACKGROUND_COLOR +'; border:1px solid transparent; border-collapse:collapse;">' +
                        '<tr style="border-collapse: collapse;">' +
                            '<td align="left" style="padding: 30px 40px 0px; font-family:poppins, helvetica, arial, sans-serif; font-size:' + Hosts.EMAIL_TEXT_SIZE +'; line-height:' + Hosts.EMAIL_TEXT_LINE_HEIGHT  +'; color:' + Hosts.EMAIL_TEXT_COLOR +'">' +
                                '<div>' +
                                    '<span><b>' + language[lang].assistance + '</b></span>' +
                                '</div>' +
                            '</td>' + 
                            '<td align="right" style="padding: 30px 40px 0px; font-family:poppins, helvetica, arial, sans-serif; font-size:' + Hosts.EMAIL_TEXT_SIZE +'; line-height:' + Hosts.EMAIL_TEXT_LINE_HEIGHT  +'; color:' + Hosts.EMAIL_TEXT_COLOR +'">' +
                                '<div>'+
                                    '<span>'+ today_aux + '</span>'+
                                '</div>'+
                            '</td>' +
                        '</tr>' +

                        '<tr>' +
                            '<td colspan="2" align="right" style="padding: 0px 40px; height: 15px;"></td>' +
                        '</tr>' +

                        '<tr style="border-collapse: collapse;">' +
                            '<td colspan="2" align="left" style="padding:40px; border-collapse:collapse; font-family:poppins, helvetica, arial, sans-serif; font-size:' + Hosts.EMAIL_TEXT_SIZE +'; line-height:' + Hosts.EMAIL_TEXT_LINE_HEIGHT  +'; color:' + Hosts.EMAIL_TEXT_COLOR +'">' +
                                '<div>'+
                                    '<span>' + language[lang].assistance_closed_email_sent + '</span>'+
                                '</div>'+
                            '</td>' +
                        '</tr>' +

                        '<tr style="border-collapse: collapse;">' +
                            '<td colspan="2" align="left" style="padding:0px 40px;border-collapse:collapse; font-family:poppins, helvetica, arial, sans-serif; font-size:' + Hosts.EMAIL_TEXT_SIZE +'; line-height:' + Hosts.EMAIL_TEXT_LINE_HEIGHT  +'; color:' + Hosts.EMAIL_TEXT_COLOR +'">' +
                                '<div>'+
                                    language[lang].access_app_txt +  ' <a alt="' + Hosts.webSiteTitle + '" title="' + Hosts.webSiteTitle + '" href="' + Hosts.EMAIL_WEB_SITE_URL + '" target="_blank">'+ language[lang].access_app_link +'</a>'+
                                '</div>'+
                            '</td>' +
                        '</tr>' +
                    
                        '<tr>' +
                            '<td colspan="2" align="right" style="height: 15px;"></td>' +
                        '</tr>' +
                    '</table>'

                    let sendFrom = Hosts.contactFrom
                    let sendTo = [user_email_aux.email]
                    let sendToCC = ['web.dev@assec.pt']
                    let subject = language[lang].subject_assistance_email
                    let content = mail_content
                    let attachment = []

                    await functionSendMail(sendFrom, sendTo, sendToCC, subject, content, attachment, dados_config)
                }

                window.location.reload()
			}
		})

    }

    const filter_for_client = (e) => {
        const { value } = e.target;

        set_selected_user_id(value)

        let list_aux = []
        let list_archive_aux = []
        assistance_list.current.forEach(el => {
            if(parseInt(el.info.id_user) === parseInt(value)) {
                list_aux.push(el)
            }
        })
        assistance_archive_list.current.forEach(el => {
            if(parseInt(el.info.id_user) === parseInt(value)) {
                list_archive_aux.push(el)
            }
        })
        set_dados(assistance_selected_list.current = list_aux)
        set_dados(assistance_archive_selected_list.current = list_archive_aux)
        set_dados(assistance_info.current = null)

    }

    const checkbox_close = () => {
        set_close(!close);
    }
  
    const checkbox_close_reload = (value) => {
        if (value === true)
            return true
        else 
            return false
    } 

    return (
        isRedirect ? 
            <Redirect to={'/'} replace />
        :
        isloading ?
            <Loader />
        :
        <>
            <Navbar pag_welcome={true} dados_config={dados_config} dados_navbar={dados_navbar} />

            <Breadcrumb /> 

            <div className="container-fluid mb-5">
                <div className="row">
                    <div className='col-12 bg-light py-5'>
                        <div className='container'>
                            <div className='row'>
                                <div className='col-12 col-lg-10'>
                                    <h3 className="titulo-primario">
                                        <span>{language[lang].assistances}</span>
                                    </h3>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='row mb-5'>
                    <div className='col-12'>
                        <div className="container">
                            <div className='row'>
                                <div className='col-12 col-lg-10 mx-auto'>
                                    <div className='row'>

                                        <div className='col-6 mx-auto mt-5 text-start'>

                                            <div className="row mb-3">
                                                <div className="col-6 col-sm-6">
                                                    {
                                                    user_access_level >= 5 ?
                                                        <select className="form-select rounded-0" aria-label="Select link" name='tipo' value={selected_user_id} onChange={(e) => filter_for_client(e)}>
                                                            <option value="">{language[lang].choose_client}</option>
                                                            {
                                                            assistance_user_names.current.map((v, k) => {
                                                                return (
                                                                    <option key={k} value={v.id}>{v.info.name}</option>
                                                                )
                                                            })
                                                            }
                                                        </select>
                                                    :
                                                        null
                                                    }
                                                </div>
                                            </div>

                                        </div>

                                        <div className='col-6 mx-auto mt-5 text-end'>
                                            {
                                            assistance_info.current !== undefined && assistance_info.current !== null ?
                                                <button type="button" className='btn btn-light rounded-0 me-2' onClick={() => { set_dados(assistance_info.current = null); set_user_name_by_id([]) }}>
                                                    {language[lang].back}
                                                </button>
                                            :
                                                null
                                            }
                                            {
                                            user_access_level < 5 ?
                                                <button type="button" className='btn btn-secondary' data-bs-toggle="modal" data-bs-target=".modal-new_ticket" onClick={() => set_dados(assistance_info.current = null)}>
                                                    {language[lang].assistance_new}
                                                </button>
                                            :
                                                null
                                            }
                                            {
                                            assistance_archive_list !== null && assistance_archive_list.current !== null && assistance_archive_list.current.length > 0 ?
                                                show_archive ? 
                                                    <button type="button" className='btn btn-secondary' onClick={() => { set_dados(assistance_info.current = null); set_show_archive(false)} }>
                                                        {language[lang].show_open}
                                                    </button>
                                                :
                                                    <button type="button" className='btn btn-secondary' onClick={() => { set_dados(assistance_info.current = null); set_show_archive(true)}}>
                                                        {language[lang].show_archive}
                                                    </button>
                                            :
                                                null
                                            }
                                        </div>

                                    </div>
                                </div>

                                {
                                !show_archive ?
                                    <div className='col-12 col-lg-10 mx-auto'>
                                        <div className="tickets-container py-5">
                                            <ul className="tickets-list">
                                                {
                                                selected_user_id === '' && assistance_list.current !== null ?
                                                    assistance_list.current.map((el, k) => {
                                                        if(assistance_info.current !== undefined && assistance_info.current !== null && assistance_info.current.id !== '') {
                                                            if(el.id === assistance_info.current.id) {
                                                                return (
                                                                    <li key={k} className="ticket-item" style={{cursor: 'pointer'}} onClick={() => show_ticket(el.id)}>
                                                                        <div className="row">
                                                                            <div className="ticket-user col-12 col-md-6">
                                                                                <span className="user-name">{el.info.name} <strong>({user_name_by_id.filter(el => el.id === assistance_info.current.info.id_user)[0]?.name})</strong></span>
                                                                            </div>
                                                                            <div className="ticket-time col-12 col-sm-6 col-md-3">
                                                                                <div className="divider d-none d-lg-block"></div>
                                                                                <i className="bi bi-clock-history me-2"></i>
                                                                                <span className="time d-none">
                                                                                    {dateDifferenceInHours(new Date(el.info.date), new Date())}
                                                                                </span>
                                                                                <small>{dateString(el.info.date)}</small>
                                                                            </div>
                                                                            <div className="ticket-type col-12 col-sm-6 col-md-3 text-end pe-4">
                                                                                <span className="divider d-none d-sm-block"></span>
                                                                                <span className="type">{el.info?.service?.name}</span>
                                                                            </div>
                                                                            <div 
                                                                                className={"ticket-state bg-" + (parseInt(el.info.state) === 0 ? "warning" : (parseInt(el.info.state) === 1 ? 'info' : 'success'))}
                                                                                title={
                                                                                    parseInt(el.info.state) === 0 ? 
                                                                                        language[lang].label_warning
                                                                                    : 
                                                                                    parseInt(el.info.state) === 1 ? 
                                                                                        language[lang].label_info
                                                                                    :  
                                                                                        language[lang].label_success
                                                                                }
                                                                            >
                                                                            </div>
                                                                        </div>
                                                                    </li>
                                                                )
                                                            }
                                                            else {
                                                                return null
                                                            }
                                                        }
                                                        else {
                                                            return (
                                                                <li key={k} className="ticket-item" style={{cursor: 'pointer'}} onClick={() => show_ticket(el.id)}>
                                                                    <div className="row">
                                                                        <div className="ticket-user col-12 col-md-6">
                                                                            <span className="user-name">{el.info.name} <strong>({assistance_user_names.current.filter(e => e.id === el.info.id_user)[0]?.info?.name})</strong></span>
                                                                        </div>
                                                                        <div className="ticket-time col-12 col-sm-6 col-md-3">
                                                                            <div className="divider d-none d-lg-block"></div>
                                                                            <i className="bi bi-clock-history me-2"></i>
                                                                            <span className="time d-none">
                                                                                {dateDifferenceInHours(new Date(el.info.date), new Date())}
                                                                            </span>
                                                                            <small>{dateString(el.info.date)}</small>
                                                                        </div>
                                                                        <div className="ticket-type col-12 col-sm-6 col-md-3 text-end pe-4">
                                                                            <span className="divider d-none d-sm-block"></span>
                                                                            <span className="type">{el.info?.service?.name}</span>
                                                                        </div>
                                                                        <div 
                                                                            className={"ticket-state bg-" + (parseInt(el.info.state) === 0 ? "warning" : (parseInt(el.info.state) === 1 ? 'info' : 'success'))}
                                                                            title={
                                                                                parseInt(el.info.state) === 0 ? 
                                                                                    language[lang].label_warning
                                                                                : 
                                                                                parseInt(el.info.state) === 1 ? 
                                                                                    language[lang].label_info
                                                                                :  
                                                                                    language[lang].label_success
                                                                            }
                                                                        >
                                                                        </div>
                                                                    </div>
                                                                </li>
                                                            )
                                                        }
                                                    })
                                                :
                                                    null
                                                }
                                                {
                                                selected_user_id !== '' && assistance_selected_list.current !== null ?
                                                    assistance_selected_list.current.map((el, k) => {
                                                        if(assistance_info.current !== undefined && assistance_info.current !== null && assistance_info.current.id !== '') {
                                                            if(el.id === assistance_info.current.id) {
                                                                return (
                                                                    <li key={k} className="ticket-item" style={{cursor: 'pointer'}} onClick={() => show_ticket(el.id)}>
                                                                        <div className="row">
                                                                            <div className="ticket-user col-12 col-md-6">
                                                                                <span className="user-name">{el.info.name} <strong>({user_name_by_id.filter(el => el.id === assistance_info.current.info.id_user)[0]?.name})</strong></span>
                                                                            </div>
                                                                            <div className="ticket-time col-12 col-sm-6 col-md-3">
                                                                                <div className="divider d-none d-lg-block"></div>
                                                                                <i className="bi bi-clock-history me-2"></i>
                                                                                <span className="time d-none">
                                                                                    {dateDifferenceInHours(new Date(el.info.date), new Date())}
                                                                                </span>
                                                                                <small>{dateString(el.info.date)}</small>
                                                                            </div>
                                                                            <div className="ticket-type col-12 col-sm-6 col-md-3 text-end pe-4">
                                                                                <span className="divider d-none d-sm-block"></span>
                                                                                <span className="type">{el.info?.service?.name}</span>
                                                                            </div>
                                                                            <div 
                                                                                className={"ticket-state bg-" + (parseInt(el.info.state) === 0 ? "warning" : (parseInt(el.info.state) === 1 ? 'info' : 'success'))}
                                                                                title={
                                                                                    parseInt(el.info.state) === 0 ? 
                                                                                        language[lang].label_warning
                                                                                    : 
                                                                                    parseInt(el.info.state) === 1 ? 
                                                                                        language[lang].label_info
                                                                                    :  
                                                                                        language[lang].label_success
                                                                                }
                                                                            >
                                                                            </div>
                                                                        </div>
                                                                    </li>
                                                                )
                                                            }
                                                            else {
                                                                return null
                                                            }
                                                        }
                                                        else {
                                                            return (
                                                                <li key={k} className="ticket-item" style={{cursor: 'pointer'}} onClick={() => show_ticket(el.id)}>
                                                                    <div className="row">
                                                                        <div className="ticket-user col-12 col-md-6">
                                                                            <span className="user-name">{el.info.name} <strong>({assistance_user_names.current.filter(e => e.id === el.info.id_user)[0]?.info?.name})</strong></span>
                                                                        </div>
                                                                        <div className="ticket-time col-12 col-sm-6 col-md-3">
                                                                            <div className="divider d-none d-lg-block"></div>
                                                                            <i className="bi bi-clock-history me-2"></i>
                                                                            <span className="time d-none">
                                                                                {dateDifferenceInHours(new Date(el.info.date), new Date())}
                                                                            </span>
                                                                            <small>{dateString(el.info.date)}</small>
                                                                        </div>
                                                                        <div className="ticket-type col-12 col-sm-6 col-md-3 text-end pe-4">
                                                                            <span className="divider d-none d-sm-block"></span>
                                                                            <span className="type">{el.info?.service?.name}</span>
                                                                        </div>
                                                                        <div 
                                                                            className={"ticket-state bg-" + (parseInt(el.info.state) === 0 ? "warning" : (parseInt(el.info.state) === 1 ? 'info' : 'success'))}
                                                                            title={
                                                                                parseInt(el.info.state) === 0 ? 
                                                                                    language[lang].label_warning
                                                                                : 
                                                                                parseInt(el.info.state) === 1 ? 
                                                                                    language[lang].label_info
                                                                                :  
                                                                                    language[lang].label_success
                                                                            }
                                                                        >
                                                                        </div>
                                                                    </div>
                                                                </li>
                                                            )
                                                        }
                                                    })
                                                :
                                                    null
                                                }
                                            </ul>
                                        </div>
                                    </div>
                                :
                                    <div className='col-12 col-lg-10 mx-auto'>
                                        <div className="tickets-container py-5">
                                            <ul className="tickets-list">
                                                {
                                                selected_user_id === '' && assistance_archive_list.current !== null ?
                                                    assistance_archive_list.current.map((el, k) => {
                                                        if(assistance_info.current !== undefined && assistance_info.current !== null && assistance_info.current.id !== '') {
                                                            if(el.id === assistance_info.current.id) {
                                                                return (
                                                                    <li key={k} className="ticket-item" style={{cursor: 'pointer'}} onClick={() => show_archived_ticket(el.id)}>
                                                                        <div className="row">
                                                                            <div className="ticket-user col-12 col-md-6">
                                                                                <span className="user-name">{el.info.name} <strong>({user_name_by_id.filter(el => el.id === assistance_info.current.info.id_user)[0]?.name})</strong></span>
                                                                            </div>
                                                                            <div className="ticket-time col-12 col-sm-6 col-md-3">
                                                                                <div className="divider d-none d-lg-block"></div>
                                                                                <i className="bi bi-clock-history me-2"></i>
                                                                                <span className="time d-none">
                                                                                    {dateDifferenceInHours(new Date(el.info.date), new Date())}
                                                                                </span>
                                                                                <small>{dateString(el.info.date)}</small>
                                                                            </div>
                                                                            <div className="ticket-type col-12 col-sm-6 col-md-3 text-end pe-4">
                                                                                <span className="divider d-none d-sm-block"></span>
                                                                                <span className="type">{el.info?.service?.name}</span>
                                                                            </div>
                                                                            <div 
                                                                                className={"ticket-state bg-" + (parseInt(el.info.state) === 0 ? "warning" : (parseInt(el.info.state) === 1 ? 'info' : 'success'))}
                                                                                title={
                                                                                    parseInt(el.info.state) === 0 ? 
                                                                                        language[lang].label_warning
                                                                                    : 
                                                                                    parseInt(el.info.state) === 1 ? 
                                                                                        language[lang].label_info
                                                                                    :  
                                                                                        language[lang].label_success
                                                                                }
                                                                            >
                                                                            </div>
                                                                        </div>
                                                                    </li>
                                                                )
                                                            }
                                                            else {
                                                                return null
                                                            }
                                                        }
                                                        else {
                                                            return (
                                                                <li key={k} className="ticket-item" style={{cursor: 'pointer'}} onClick={() => show_archived_ticket(el.id)}>
                                                                    <div className="row">
                                                                        <div className="ticket-user col-12 col-md-6">
                                                                            <span className="user-name">{el.info.name} <strong>({assistance_user_names.current.filter(e => e.id === el.info.id_user)[0]?.info?.name})</strong></span>
                                                                        </div>
                                                                        <div className="ticket-time col-12 col-sm-6 col-md-3">
                                                                            <div className="divider d-none d-lg-block"></div>
                                                                            <i className="bi bi-clock-history me-2"></i>
                                                                            <span className="time d-none">
                                                                                {dateDifferenceInHours(new Date(el.info.date), new Date())}
                                                                            </span>
                                                                            <small>{dateString(el.info.date)}</small>
                                                                        </div>
                                                                        <div className="ticket-type col-12 col-sm-6 col-md-3 text-end pe-4">
                                                                            <span className="divider d-none d-sm-block"></span>
                                                                            <span className="type">{el.info?.service?.name}</span>
                                                                        </div>
                                                                        <div 
                                                                            className={"ticket-state bg-" + (parseInt(el.info.state) === 0 ? "warning" : (parseInt(el.info.state) === 1 ? 'info' : 'success'))}
                                                                            title={
                                                                                parseInt(el.info.state) === 0 ? 
                                                                                    language[lang].label_warning
                                                                                : 
                                                                                parseInt(el.info.state) === 1 ? 
                                                                                    language[lang].label_info
                                                                                :  
                                                                                    language[lang].label_success
                                                                            }
                                                                        >
                                                                        </div>
                                                                    </div>
                                                                </li>
                                                            )

                                                        }
                                                    })
                                                :
                                                    null
                                                }
                                                {
                                                selected_user_id !== '' && assistance_archive_selected_list.current !== null ?
                                                    assistance_archive_selected_list.current.map((el, k) => {
                                                        if(assistance_info.current !== undefined && assistance_info.current !== null && assistance_info.current.id !== '') {
                                                            if(el.id === assistance_info.current.id) {
                                                                return (
                                                                    <li key={k} className="ticket-item" style={{cursor: 'pointer'}} onClick={() => show_ticket(el.id)}>
                                                                        <div className="row">
                                                                            <div className="ticket-user col-12 col-md-6">
                                                                                <span className="user-name">{el.info.name} <strong>({user_name_by_id.filter(el => el.id === assistance_info.current.info.id_user)[0]?.name})</strong></span>
                                                                            </div>
                                                                            <div className="ticket-time col-12 col-sm-6 col-md-3">
                                                                                <div className="divider d-none d-lg-block"></div>
                                                                                <i className="bi bi-clock-history me-2"></i>
                                                                                <span className="time d-none">
                                                                                    {dateDifferenceInHours(new Date(el.info.date), new Date())}
                                                                                </span>
                                                                                <small>{dateString(el.info.date)}</small>
                                                                            </div>
                                                                            <div className="ticket-type col-12 col-sm-6 col-md-3 text-end pe-4">
                                                                                <span className="divider d-none d-sm-block"></span>
                                                                                <span className="type">{el.info?.service?.name}</span>
                                                                            </div>
                                                                            <div 
                                                                                className={"ticket-state bg-" + (parseInt(el.info.state) === 0 ? "warning" : (parseInt(el.info.state) === 1 ? 'info' : 'success'))}
                                                                                title={
                                                                                    parseInt(el.info.state) === 0 ? 
                                                                                        language[lang].label_warning
                                                                                    : 
                                                                                    parseInt(el.info.state) === 1 ? 
                                                                                        language[lang].label_info
                                                                                    :  
                                                                                        language[lang].label_success
                                                                                }
                                                                            >
                                                                            </div>
                                                                        </div>
                                                                    </li>
                                                                )
                                                            }
                                                            else {
                                                                return null
                                                            }
                                                        }
                                                        else {
                                                            return (
                                                                <li key={k} className="ticket-item" style={{cursor: 'pointer'}} onClick={() => show_ticket(el.id)}>
                                                                    <div className="row">
                                                                        <div className="ticket-user col-12 col-md-6">
                                                                            <span className="user-name">{el.info.name} <strong>({assistance_user_names.current.filter(e => e.id === el.info.id_user)[0]?.info?.name})</strong></span>
                                                                        </div>
                                                                        <div className="ticket-time col-12 col-sm-6 col-md-3">
                                                                            <div className="divider d-none d-lg-block"></div>
                                                                            <i className="bi bi-clock-history me-2"></i>
                                                                            <span className="time d-none">
                                                                                {dateDifferenceInHours(new Date(el.info.date), new Date())}
                                                                            </span>
                                                                            <small>{dateString(el.info.date)}</small>
                                                                        </div>
                                                                        <div className="ticket-type col-12 col-sm-6 col-md-3 text-end pe-4">
                                                                            <span className="divider d-none d-sm-block"></span>
                                                                            <span className="type">{el.info?.service?.name}</span>
                                                                        </div>
                                                                        <div 
                                                                            className={"ticket-state bg-" + (parseInt(el.info.state) === 0 ? "warning" : (parseInt(el.info.state) === 1 ? 'info' : 'success'))}
                                                                            title={
                                                                                parseInt(el.info.state) === 0 ? 
                                                                                    language[lang].label_warning
                                                                                : 
                                                                                parseInt(el.info.state) === 1 ? 
                                                                                    language[lang].label_info
                                                                                :  
                                                                                    language[lang].label_success
                                                                            }
                                                                        >
                                                                        </div>
                                                                    </div>
                                                                </li>
                                                            )
                                                        }
                                                    })
                                                :
                                                    null
                                                }
                                            </ul>
                                        </div>
                                    </div>
                                }

                                <div className="modal fade modal-new_ticket" tabIndex="-1" role="dialog" aria-labelledby="my-largeModalLabel" aria-hidden="true">
                                    <div className="modal-dialog modal-lg">
                                        <div className="modal-content">
                                            <div className="modal-header">
                                                <h5 className="modal-title" id="exampleModalLabel">{language[lang].assistance_new}</h5>
                                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                                            </div>

                                            <div className="modal-body">
                                                <div className='col-12'>
                                                    <div className="row mb-3">
                                                        <div className="col-6 col-sm-6">
                                                            <label className="form-label">{language[lang].service} *</label>
                                                            <select className="form-select rounded-0" aria-label="Select link" name='tipo' value={assistance_new.current.info?.service?.id} onChange={(e) => handle_change_info_service(e)}>
                                                                <option value="">{language[lang].choose_link}</option>
                                                                {
                                                                services.map((v, k) => {
                                                                    return (
                                                                        <option key={k} value={v.id}>{v.info.name}</option>
                                                                    )
                                                                })
                                                                }
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className="row mb-3">
                                                        <div className="col-12">
                                                            <label className="form-label">{language[lang].assistance} *</label>
                                                            <input 
                                                                type="text" 
                                                                name="name" 
                                                                className="form-control rounded-0" 
                                                                placeholder="" 
                                                                value={assistance_new.current?.info?.name} 
                                                                onChange={handle_change_info}
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="row mb-3">
                                                        <div className="col-12">
                                                            <label className="form-label">{language[lang].message} *</label>
                                                            <textarea 
                                                                type="text" 
                                                                rows="4" 
                                                                name="message" 
                                                                className="form-control rounded-0" 
                                                                placeholder="" 
                                                                value={assistance_new.current?.info?.message} 
                                                                onChange={handle_change_info} 
                                                                required
                                                            />
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>

                                            <div className="modal-footer">
                                                <button disabled={assistance_new.current?.info?.name === '' || assistance_new.current?.info?.message === ''} type="button" className="btn btn-secondary px-4" data-bs-dismiss="modal" onClick={handleSubmit}> {language[lang].send} </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>

                            {
                            assistance_info.current !== undefined && assistance_info.current !== null ?
                                <div className='row'>
                                    <div className='col-12 col-lg-10 mx-auto'>
                                        {
                                        parseInt(assistance_info.current.info.state) >= 2 ?
                                            <div className="response-div">
                                                <div className="row">
                                                    <div className='col-12 text-end mb-5'>
                                                        <span className="bg bg-primary text-white px-4 py-2 me-2"> 
                                                            {language[lang].assistance_closed} 
                                                        </span>
                                                    </div>
                                                </div>
                                                
                                            </div>
                                        :
                                            null
                                        }
                                        <div className="chat_container">
                                            <div className="job-box">
                                                <div className="inbox-message">
                                                    <ul>
                                                        <li>
                                                            <div className="message-div">
                                                                <div className="message-avatar">
                                                                    <i className="bi bi-person-circle"></i>
                                                                </div>
                                                                <div className="message-body">
                                                                    <div className="message-body-heading">
                                                                        <h6>
                                                                            <small> {user_name_by_id.filter(el => el.id === assistance_info.current.info.id_user)[0]?.name} </small>
                                                                            <strong> @ {assistance_info.current.info.name} </strong>
                                                                            {
                                                                            assistance_info.current.info.interaction.length === 0 ?
                                                                                <span className="bg-info">{language[lang].unread}</span>
                                                                            :
                                                                                null
                                                                            }
                                                                        </h6>
                                                                        <span>{dateDifferenceInHours(new Date(assistance_info.current.info.date), new Date())}</span>
                                                                    </div>
                                                                    <p>{assistance_info.current.info.message}</p>
                                                                </div>
                                                            </div>
                                                        </li>
                                                        {
                                                        assistance_info.current.info.interaction.length > 0 ?
                                                            assistance_info.current.info.interaction.map((el_int, k_int) => {
                                                                return (
                                                                    <li key={k_int}>
                                                                        <div className="message-div">
                                                                            <div className="message-avatar">
                                                                                <i className="bi bi-person-circle"></i>
                                                                            </div>
                                                                            <div className="message-body">
                                                                                <div className="message-body-heading">
                                                                                    <h6>
                                                                                        <small> {user_name_by_id.filter(el => el.id === el_int.id_user)[0]?.name} </small>
                                                                                        <strong> @ {assistance_info.current.info.name} </strong>
                                                                                        {
                                                                                        parseInt(el_int.state) === 0 ?
                                                                                            <span className="bg-info">{language[lang].unread}</span>
                                                                                        :
                                                                                            null
                                                                                        }
                                                                                    </h6>
                                                                                    <span>{dateDifferenceInHours(new Date(el_int.date), new Date())}</span>
                                                                                </div>
                                                                                <p>{el_int.message}</p>
                                                                            </div>
                                                                        </div>
                                                                    </li>
                                                                )
                                                            })
                                                        :
                                                            null
                                                        }
                                                        {
                                                        parseInt(assistance_info.current.info.state) < 2 ?
                                                            <li>
                                                                <div className="response-div">
                                                                    <div className="row my-3">
                                                                        <div className="col-12">
                                                                            <label className="form-label">{language[lang].new_message} *</label>
                                                                            <textarea 
                                                                                type="text" 
                                                                                rows="4" 
                                                                                name="message" 
                                                                                className="form-control rounded-0" 
                                                                                placeholder="" 
                                                                                value={response}
                                                                                onChange={(e) => edit_response(e)} 
                                                                                required
                                                                            />
                                                                        </div>

                                                                        <div className='col-12 text-end mt-3 d-flex align-items-center justify-content-end'>
                                                                            {
                                                                            user_access_level >= 5 ?
                                                                                <>
                                                                                    <input type="checkbox" id="close" onChange={checkbox_close} defaultChecked={checkbox_close_reload(close)} />
                                                                                    <label className="px-3" htmlFor="close">{language[lang].assistance_close}</label>
                                                                                    <button type="button" className="btn btn-secondary px-4 me-2 d-none" onClick={() => close_ticket()}> {language[lang].assistance_close} </button>
                                                                                </>
                                                                            :
                                                                                null
                                                                            }
                                                                            <button type="button" className="btn btn-secondary px-4" onClick={() => send_response()}> {language[lang].new_send} </button>
                                                                        </div>
                                                                    </div>
                                                                    
                                                                </div>
                                                            </li>
                                                        :
                                                            null
                                                        }
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            :
                                user_name_by_id !== undefined && user_name_by_id !== null && user_name_by_id.length > 0 ?
                                    <div className='row mb-5'>
                                        <div className='col-12 mb-5 mx-auto text-center'>
                                            {language[lang].table_empty}
                                        </div>
                                    </div>
                                :
                                    null
                            }
                        </div>
                    </div>
                </div>
            </div>

            <Footer pag_welcome={true} dados_config={dados_config} dados_navbar={dados_navbar} />
        </>

    );
}

